// import React from 'react'
import DataTable from "react-data-table-component";
import SurveyListData from "./SurveyListData";
import Axios from "axios";
import TimeAgo from "react-timeago";
import props from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Svg from "./Svg";
import Card from "../../core/Card";
import style from "../../views/style.module.css";
import moment from "moment";
import Input from "../../core/Inputs/DefaultInput";
import { useDispatch } from "react-redux";
import {
  deleteSurvey,
  duplicateSurvey,
  getSurveyList,
  moveToDraftSurvey,
  moveToPublishSurvey,
} from "../../store/actions/surveyAction";
import { SET_SURVEY_ID, SET_SURVEY_NAME } from "../../store/constant";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  getLanguages,
  addSurveyAssignTo,
  getSurveyAssignTo,
} from "../../store/actions/surveyAction";
import Select from "react-select";
import { toast } from "react-toastify";
import { getTeamList } from "../../store/actions/teamAction";

const SURVEY_URL = process.env.REACT_APP_USER_LINK;
const language_code = "22";

export default function Inventory({
  userId,
  filters,
  onSelectedRowsChange,
  refreshKey,
}) {
  //==> States <==

  //state
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [sort, setSort] = useState("DESC");
  const [currentlyDeleting, setCurrentlyDeleting] = useState({
    name: null,
    id: null,
  });
  const [sortby, setSortby] = useState("su_survey_modified_date_time");

  //Modal

  const [isDuplicateSurveyModalOpen, setIsDuplicateSurveyModalOpen] =
    useState(false);
  const [duplicatingSurveyName, setDuplicatingSurveyName] = useState("");
  const [duplicatingSurveyId, setDuplicatingSurveyId] = useState(null);
  const [assignSurveyId, setAssignSurveyId] = useState(null);
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [isSyncOptionsModalOpen, setIsSyncOptionsModalOpen] = useState(false);
  const [syncMode, setSyncMode] = useState("full"); // 'full' | 'merge'
  const [syncTargetSurvey, setSyncTargetSurvey] = useState({
    id: null,
    name: "",
    languageCode: null,
  });
  const [isSyncing, setIsSyncing] = useState(false);
  const [lastSyncVersion, setLastSyncVersion] = useState(null);
  const [isVersionHistoryModalOpen, setIsVersionHistoryModalOpen] =
    useState(false);
  const [versionHistoryLoading, setVersionHistoryLoading] = useState(false);
  const [restoringVersionId, setRestoringVersionId] = useState(null);
  const [versionHistoryRows, setVersionHistoryRows] = useState([]);
  const [versionHistoryError, setVersionHistoryError] = useState("");
  // Merge Preview state
  const [isMergePreviewModalOpen, setIsMergePreviewModalOpen] = useState(false);
  const [mergePreviewData, setMergePreviewData] = useState(null);
  const [mergePreviewLoading, setMergePreviewLoading] = useState(false);
  const [mergeExecuting, setMergeExecuting] = useState(false);
  const [assignSurveyNameError, setAssignSurveyNameError] = useState(false);
  const [assignSurveyName, setAssignSurveyName] = useState("");
  const [duplicatingSurveyNameError, setDuplicatingSurveyNameError] =
    useState(false);
  const { languageList, surveyAssignToData } = useSelector(
    (state) => state.surveyData,
  );
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [selectedLTeam, setSelectedTeam] = useState(null);
  const [isDuplicating, setIsDuplicating] = useState(false);
  const [hoveredSurveyId, setHoveredSurveyId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [serverParams, setServerParams] = useState({
    startingLimit: 0,
    resultsPerPage: 8,
    search: "",
    sort_by: "team_name",
    sort_order: "asc",
  });

  const {
    teamDataLoading,
    teamData: teamList,
    teamDetail: teamDetail,
    teamMembers: teamMembers,
  } = useSelector((state) => state.teamData);

  //Others
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    surveyDataLoading: loading,
    surveyData: surveyList,
    totalRecords,
  } = useSelector((state) => state.surveyData);
  const { userData } = useSelector((state) => state.userDataHeader);
  const isAdmin = userData?.[0]?.role_name === "Admin";
  console.log("isAdmin:", isAdmin);

  useEffect(() => {
    console.log("Dispatching getLanguages API...");
    dispatch(getLanguages()); // Fetch languages on mount
  }, [dispatch]);

  useEffect(() => {
    console.log("Dispatching getLanguages API...");
    dispatch(getTeamList(serverParams));
  }, [dispatch]);

  const unsecuredCopyToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
    } catch (err) {
      console.error("Unable to copy to clipboard", err);
    }
    document.body.removeChild(textArea);
  };

  const handleCopy = (link) => {
    navigator?.clipboard
      ? navigator?.clipboard.writeText(link)
      : unsecuredCopyToClipboard(link);
    toast.success(t("sync.toast.linkCopied"), {});
  };

  //Column
  const columns = [
    // {
    //   name: t('survey.surveyName'),
    //   sortable: true,
    //   width: "200px",
    //   cell: row => {
    //     return <>
    //       <div className="w-100">
    //         {/* <a className="table-name" data-bs-toggle="modal" data-bs-target="#languageListModal" aria-haspopup="true" aria-expanded="false">
    //           {row.survey_name ? JSON.parse(row.survey_name)[language_code] : 'Draft_Survey'}
    //         </a> */}
    //         <span className="surv-title">
    //           {row.survey_name ? JSON.parse(row.survey_name)[language_code] : '-'}
    //         </span>
    //         <div className="secondary-text">{(row.totalSection !== undefined || row.totalSection !== null) && `${row.totalSection} Sections`} {(row.totalQuestion !== undefined || row.totalQuestion !== null) && `,${row.totalQuestion} Questions`} </div>
    //       </div>
    //     </>
    //   }
    // },

    {
      name: t("survey.surveyName"),
      sortable: true,
      width: "180px",
      cell: (row) => {
        let surveyName = "-";

        try {
          const surveyNameObj = row.survey_name
            ? JSON.parse(row.survey_name)
            : {};
          const languageCode = row.su_languages?.split(",")[0]; // Use first language from su_languages
          surveyName =
            surveyNameObj[languageCode] ||
            Object.values(surveyNameObj)[0] ||
            "-";
        } catch (error) {
          console.error("Error parsing survey name:", error);
        }

        return (
          <div className="w-100">
            <span
              className="surv-title"
              style={{
                cursor: "pointer",
                color: hoveredSurveyId === row.survey_id ? "red" : undefined,
              }}
              title={t("survey.actions.editSurvey")}
              onMouseEnter={() => setHoveredSurveyId(row.survey_id)}
              onMouseLeave={() => setHoveredSurveyId(null)}
              onClick={() => editSurvey(row)}
            >
              {surveyName}
            </span>
            <div className="secondary-text">
              {(row.totalSection !== undefined || row.totalSection !== null) &&
                `${row.totalSection}  ${t("survey.sections")}`}{" "}
              {(row.totalQuestion !== undefined ||
                row.totalQuestion !== null) &&
                `,${row.totalQuestion} ${t("survey.questions")}`}{" "}
            </div>
          </div>
        );
      },
    },

    {
      name: t("survey.completionResponses"),
      selector: (row) => row.Responses,
      sortable: true,
      // width: '280px',
      cell: (row) => (
        <>
          <div className="w-100 response-complete">
            {" "}
            {row.totalCompletedResponse ?? ""}/{row.totalResponse ?? ""}
          </div>
        </>
      ),
    },

    {
      name: t("survey.language"),
      selector: (row) => row.language_name,
      // width: '280px',
      cell: (row) => (
        <>
          <div className="w-100 response-complete">
            {" "}
            {row.language_name ?? ""}
          </div>
        </>
      ),
    },

    {
      name: t("survey.status"),
      selector: (row) => row.su_is_active,
      sortable: true,
      // width: '120px',
      cell: (row) => {
        return (
          <>
            <div className="w-100">
              <span
                className={
                  "table-status" +
                  " " +
                  (Number(row.status) === 1
                    ? "Active"
                    : Number(row.status) === 0
                      ? "Inactive"
                      : "Draft")
                }
              >
                {Number(row.status) === 1
                  ? t("survey.published")
                  : Number(row.status) === 0
                    ? "Pending"
                    : t("survey.draft")}
              </span>
            </div>
          </>
        );
      },
    },

    {
      name: t("survey.shareLink"),
      selector: (row) => row?.Responses,
      sortable: false,
      // width: '280px',
      cell: (row) => (
        <>
          <div className="text-center w-100">
            <button
              type="button"
              className="copy-link"
              //title="Copy link"
              onClick={() => {
                handleCopy(`${SURVEY_URL}/${row?.survey_id}`);
              }}
              style={{
                pointerEvents: row?.survey_id ? "auto" : "none",
                opacity: row?.survey_id ? 1 : 0.5,
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
              }}
            >
              <Svg name="share" />
            </button>
          </div>
        </>
      ),
    },

    {
      name: t("webhook.assign"),
      selector: (row) => row.team_name,
      // width: '280px',
      cell: (row) => (
        <>
          <div className="w-100 response-complete"> {row.team_name ?? ""}</div>
        </>
      ),
    },
    {
      name: t("survey.addedOnAddedBy"),
      selector: (row) => row.smText,
      sortable: true,
      // width: '230px',
      cell: (row) => {
        let formattedPublishedOn = "";

        if (row.added_on) {
          // Use moment to parse and format the date
          formattedPublishedOn = moment(
            row.published_on,
            "DD-MM-YYYY | hh:mm A",
          ).format("DD-MM-YYYY");
        }
        return (
          <>
            <div className="w-100 text-center">
              {formattedPublishedOn}
              <div className="secondary-text bold">
                {row?.addedByName ?? ""}
              </div>
            </div>
          </>
        );
      },
    },

    //Last modify
    // {
    //   name: t('survey.lastModified'),
    //   selector: (row) => row.smText,
    //   sortable: true,
    //   // width: '180px',
    //   cell: row => <>
    //     <div className='text-center w-100'>
    //       <TimeAgo date={row.last_modified} className="time-ago" />
    //     </div>
    //   </>
    // },

    {
      name: t("survey.publishedOn"),
      selector: (row) => row.smText,
      sortable: true,
      // width: '180px',
      cell: (row) => {
        let formattedPublishedOn = "";

        if (row.published_on) {
          // Use moment to parse and format the date
          formattedPublishedOn = moment(
            row.published_on,
            "DD-MM-YYYY | hh:mm A",
          ).format("DD-MM-YYYY");
        }
        return (
          <>
            <div className="w-100"> {formattedPublishedOn} </div>
          </>
        );
      },
    },

    // {
    //   name: "Published on",
    //   selector: (row) => row.smText,
    //   sortable: true,
    //   // width: '180px',
    //   cell: row => {
    //     let formattedToday = ''
    //     if (row.published_on) {
    //       let date = new Date(row.published_on)
    //       const yyyy = date.getFullYear();
    //       let mm = date.getMonth() + 1;
    //       let dd = date.getDate();

    //       if (dd < 10) dd = '0' + dd;
    //       if (mm < 10) mm = '0' + mm;

    //       formattedToday = dd + '-' + mm + '-' + yyyy;
    //     }

    //     return <>
    //       <div className='w-100'> {formattedToday} </div>
    //     </>
    //   }
    // },
    {
      name: t("survey.customVariable.action"),
      width: "85px",
      cell: (row) => (
        <>
          <div className="dropdown table-dropdown aaa">
            <button
              className="btn dropdown-tgl"
              type="button"
              id="viewoptions"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <Svg name="action" />
            </button>
            <div className="dropdown-menu" aria-labelledby="viewoptions">
              {window.modulePermissions.M1.edit == 1 && (
                <span
                  className="dropdown-item d-flex align-items-center"
                  onClick={() => editSurvey(row)}
                >
                  <div className="icon-circle me-3">
                    <Svg name="Edit-Survey" />
                  </div>
                  <span className="dropdown-item">
                    {" "}
                    {t("survey.actions.editSurvey")}
                  </span>
                </span>
              )}
              {window.modulePermissions.M1.edit == 1 && (
                <span
                  className="dropdown-item d-flex align-items-center"
                  onClick={() => shareSurvey(row)}
                >
                  <div className="icon-circle me-3">
                    <Svg name="share" />
                  </div>
                  <span className="dropdown-item">
                    {t("survey.actions.shareSurvey")}
                  </span>
                </span>
              )}
              {window.modulePermissions.M1.edit == 1 && row.status !== 2 && (
                <span
                  className="dropdown-item d-flex align-items-center"
                  onClick={() => moveToDraft(row.survey_id)}
                >
                  <div className="icon-circle me-3">
                    <Svg name="moveLoad" />
                  </div>
                  <span className="dropdown-item">
                    {" "}
                    {t("survey.actions.moveToDraft")}
                  </span>
                </span>
              )}
              {window.modulePermissions.M1.edit == 1 && row.status == 2 && (
                <span
                  className="dropdown-item d-flex align-items-center"
                  onClick={() => moveToPublish(row.survey_id)}
                >
                  <div className="icon-circle me-3">
                    <Svg name="moveLoad" />
                  </div>
                  <span className="dropdown-item">
                    {t("survey.actions.moveToPublish")}
                  </span>
                </span>
              )}
              {window.modulePermissions.M2.view == 1 && (
                <span
                  className="dropdown-item d-flex align-items-center"
                  onClick={() =>
                    navigate(
                      `/admin/analytics/leads?survey_id=${row?.survey_id}&r=${row?.default_report}`,
                    )
                  }
                >
                  <div className="icon-circle me-3">
                    <Svg name="viewReport" />
                  </div>
                  <span className="dropdown-item">
                    {t("survey.actions.viewLeads")}
                  </span>
                </span>
              )}
              {window.modulePermissions.M1.edit == 1 && (
                <span
                  className="dropdown-item d-flex align-items-center"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => handleDuplicateSurveyModalOpen(row?.survey_id)}
                >
                  <div className="icon-circle me-3">
                    <Svg name="duplicate" />
                  </div>
                  <span className="dropdown-item">
                    {t("survey.actions.duplicate")}
                  </span>
                </span>
              )}
              {/* {assign to} */}

              {isAdmin && (
                <span
                  className="dropdown-item d-flex align-items-center"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => handleAssignModalOpen(row?.survey_id)}
                >
                  <div className="icon-circle me-3">
                    <Svg name="assign-to" />
                  </div>
                  <span className="dropdown-item">{t("survey.assignTO")}</span>
                </span>
              )}

              {/* Sync from UAT - Only visible in Production/Live environment */}
              {window.modulePermissions.M1.edit == 1 &&
                process.env.REACT_APP_ENABLE_UAT_SYNC === "true" && (
                  <span
                    className="dropdown-item d-flex align-items-center"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => openSyncOptionsModal(row)}
                  >
                    <div className="icon-circle me-3">
                      <Svg name="duplicate" />
                    </div>
                    <span className="dropdown-item">
                      {t("sync.syncFromUat")}
                    </span>
                  </span>
                )}

              {/* Version History */}
              {window.modulePermissions.M1.edit == 1 &&
                process.env.REACT_APP_ENABLE_UAT_SYNC === "true" && (
                  <span
                    className="dropdown-item d-flex align-items-center"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => openVersionHistoryModal(row)}
                  >
                    <div className="icon-circle me-3">
                      <Svg name="viewReport" />
                    </div>
                    <span className="dropdown-item">
                      {t("sync.versionHistory")}
                    </span>
                  </span>
                )}

              {window.modulePermissions.M1.del == 1 && (
                <span
                  className="dropdown-item d-flex align-items-center"
                  data-bs-toggle="modal"
                  data-bs-target="#deleteSurveyModal"
                  onClick={() =>
                    setCurrentlyDeleting({
                      name: row.survey_name
                        ? JSON.parse(row.survey_name)[language_code]
                        : ("Draft_Survey" ?? ""),
                      id: row?.survey_id,
                    })
                  }
                >
                  <div className="icon-circle me-3">
                    <Svg name="delete" />
                  </div>
                  <span className="dropdown-item">
                    {t("survey.actions.delete")}
                  </span>
                </span>
              )}
            </div>
          </div>
        </>
      ),
    },
  ];

  //==> Functionalities <==

  //Survey control
  const getSurveyDisplayName = (row) => {
    try {
      const languageCode = row?.su_languages?.split(",")?.[0];
      const obj = row?.survey_name ? JSON.parse(row.survey_name) : {};
      const name =
        obj?.[languageCode] || Object.values(obj || {})[0] || "Draft_Survey";
      return { name, languageCode };
    } catch (e) {
      return { name: "Draft_Survey", languageCode: null };
    }
  };

  const openSyncOptionsModal = (row) => {
    const { name, languageCode } = getSurveyDisplayName(row);
    setSyncTargetSurvey({ id: row?.survey_id, name, languageCode });
    setSyncMode("full");
    setIsSyncOptionsModalOpen(true);
  };

  const resetSyncOptionsModal = () => {
    setIsSyncOptionsModalOpen(false);
    setSyncMode("full");
    setSyncTargetSurvey({ id: null, name: "", languageCode: null });
    setIsSyncing(false);
  };

  // Version History (Rollback UI only)
  const openVersionHistoryModal = async (row) => {
    const { name, languageCode } = getSurveyDisplayName(row);
    const surveyId = row?.survey_id;
    setSyncTargetSurvey({ id: surveyId, name, languageCode }); // reuse for header display

    setIsVersionHistoryModalOpen(true);
    setVersionHistoryError("");
    setVersionHistoryRows([]);

    if (!surveyId) return;

    setVersionHistoryLoading(true);
    try {
      const token = localStorage.getItem("token_id");
      const url = `${process.env.REACT_APP_NODE_API_URL}/survey/getVersionHistory`;
      const resp = await Axios({
        method: "GET",
        url,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          survey_id: surveyId,
          limit: "5",
        },
      });
      setVersionHistoryRows(resp?.data?.data || []);
    } catch (err) {
      const msg =
        err?.response?.data?.msg ||
        err?.message ||
        "Failed to load version history";
      setVersionHistoryError(msg);
    } finally {
      setVersionHistoryLoading(false);
    }
  };

  const resetVersionHistoryModal = () => {
    setIsVersionHistoryModalOpen(false);
    setVersionHistoryLoading(false);
    setVersionHistoryRows([]);
    setVersionHistoryError("");
    setRestoringVersionId(null);
  };

  // Handle Restore version (Rollback)
  const handleRestore = async (version) => {
    if (!version?.version_id) {
      toast.error(t("sync.toast.invalidVersionSelected"));
      return;
    }

    setRestoringVersionId(version.version_id);
    try {
      const token = localStorage.getItem("token_id");
      const url = `${process.env.REACT_APP_NODE_API_URL}/survey/restoreSurveyVersion`;

      const resp = await Axios({
        method: "POST",
        url,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: {
          version_id: version.version_id,
          user_id: userId || null,
        },
      });

      const data = resp?.data?.data;
      const restoredVersion = data?.restored_version;
      const backupVersion = data?.backup_version;

      toast.success(
        t("sync.toast.restoredSuccess", {
          version: restoredVersion,
          backup: backupVersion,
        }),
        { autoClose: 5000 },
      );

      // Refresh the survey list
      fetchPageData();
      resetVersionHistoryModal();
    } catch (err) {
      const msg =
        err?.response?.data?.msg ||
        err?.message ||
        t("sync.toast.restoreFailed");
      toast.error(msg);
      setRestoringVersionId(null);
    }
  };

  // Full Replacement Sync from UAT (with versioning)
  const handleFullReplacementSync = async () => {
    if (!syncTargetSurvey?.id) {
      toast.error(t("sync.toast.noSurveySelected"));
      return;
    }

    setIsSyncing(true);
    try {
      const token = localStorage.getItem("token_id");
      const url = `${process.env.REACT_APP_NODE_API_URL}/survey/fullReplaceSurveyFromUAT`;

      const resp = await Axios({
        method: "POST",
        url,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: {
          survey_id: syncTargetSurvey.id,
          language_code: syncTargetSurvey.languageCode || null,
          user_id: userId || null,
        },
      });

      const data = resp?.data?.data;
      const version = data?.version;
      const wasReplacement = data?.was_replacement;

      // Show success message with version info
      if (version && wasReplacement) {
        toast.success(
          t("sync.toast.syncCompletedWithBackup", {
            version: version.version_number,
          }),
          { autoClose: 5000 },
        );
        setLastSyncVersion(version);
      } else {
        toast.success(resp?.data?.msg || t("sync.toast.surveySyncedSuccess"));
      }

      // Refresh the survey list
      fetchPageData();
      resetSyncOptionsModal();
    } catch (err) {
      const msg =
        err?.response?.data?.msg ||
        err?.message ||
        t("sync.toast.fullReplacementFailed");
      toast.error(msg);
      setIsSyncing(false);
    }
  };

  // Handle Sync button click based on mode
  const handleSyncClick = () => {
    if (syncMode === "full") {
      handleFullReplacementSync();
    } else if (syncMode === "merge") {
      // For merge mode, user must click Preview first, then Accept from preview modal
      toast.info(t("sync.toast.clickPreviewFirst"));
    }
  };

  // Handle Preview button click for Merge mode
  const handlePreviewClick = async () => {
    if (!syncTargetSurvey?.id) {
      toast.error(t("sync.toast.noSurveySelected"));
      return;
    }

    setMergePreviewLoading(true);
    try {
      const token = localStorage.getItem("token_id");
      const url = `${process.env.REACT_APP_NODE_API_URL}/survey/previewMerge`;

      const resp = await Axios({
        method: "POST",
        url,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: {
          survey_id: syncTargetSurvey.id,
        },
      });

      setMergePreviewData(resp?.data?.data);
      setIsMergePreviewModalOpen(true);
    } catch (err) {
      const msg =
        err?.response?.data?.msg ||
        err?.message ||
        t("sync.toast.previewFailed");
      toast.error(msg);
    } finally {
      setMergePreviewLoading(false);
    }
  };

  // Handle merge execution after user approves
  const handleExecuteMerge = async () => {
    if (!syncTargetSurvey?.id) {
      toast.error(t("sync.toast.noSurveySelected"));
      return;
    }

    setMergeExecuting(true);
    try {
      const token = localStorage.getItem("token_id");
      const url = `${process.env.REACT_APP_NODE_API_URL}/survey/executeMerge`;

      const resp = await Axios({
        method: "POST",
        url,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: {
          survey_id: syncTargetSurvey.id,
          user_id: userId || null,
          user_approved: true,
        },
      });

      toast.success(resp?.data?.msg || t("sync.toast.mergeCompletedSuccess"), {
        autoClose: 5000,
      });

      // Refresh survey list
      fetchPageData();
      closeMergePreviewModal();
      resetSyncOptionsModal();
    } catch (err) {
      const msg =
        err?.response?.data?.msg || err?.message || t("sync.toast.mergeFailed");
      toast.error(msg);
      setMergeExecuting(false);
    }
  };

  const closeMergePreviewModal = () => {
    setIsMergePreviewModalOpen(false);
    setMergePreviewData(null);
    setMergeExecuting(false);
  };

  const editSurvey = (row) => {
    const survey_id = row.survey_id;
    const languageCode = row.su_languages?.split(",")[0];
    const survey_name = row.survey_name
      ? JSON.parse(row.survey_name)[languageCode]
      : "Draft_Survey";
    localStorage.setItem("survey_id", survey_id);
    dispatch({ type: SET_SURVEY_ID, payload: survey_id });
    dispatch({ type: SET_SURVEY_NAME, payload: survey_name });
    navigate(`/admin/survey/create/qa-builder?survey_id=${survey_id}`);
  };

  const shareSurvey = (row) => {
    const survey_id = row.survey_id;
    const languageCode = row.su_languages?.split(",")[0];
    const survey_name = row.survey_name
      ? JSON.parse(row.survey_name)[languageCode]
      : "Draft_Survey";
    localStorage.setItem("survey_id", survey_id);
    dispatch({ type: SET_SURVEY_ID, payload: survey_id });
    dispatch({ type: SET_SURVEY_NAME, payload: survey_name });
    navigate(`/admin/survey/share?survey_id=${survey_id}`);
  };

  const vfToastStyle = { background: '#333', color: '#fff', fontWeight: 500, fontSize: '14px', borderRadius: '8px', boxShadow: '0 4px 20px rgba(0,0,0,0.25)' };
  const vfProgressStyle = { background: '#E60000' };
  const vfToastIcon = ({ theme }) => <span style={{ display: 'inline-block', width: 20, height: 20, border: '3px solid #E60000', borderTop: '3px solid transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />;

  const handleDeleteSurvey = (survey_id) => {
    const toastId = toast.loading(t("survey.actions.delete") + "...", { style: vfToastStyle, icon: vfToastIcon });
    const successCallback = () => {
      fetchPageData();
      setCurrentlyDeleting({ name: null, id: null });
      toast.dismiss(toastId);
      toast.success(t("sync.toast.surveyDeletedSuccess"));
    };
    const errorCallback = () => {
      toast.dismiss(toastId);
      toast.error(t("sync.toast.surveyDeleteFailed"));
    };
    const payload = {
      survey_id: survey_id,
    };
    dispatch(deleteSurvey(payload, successCallback, errorCallback));
  };

  // const handleDuplicateSurvey = (survey_name, survey_id) => {
  //   const successCallback = () => {
  //     fetchPageData()
  //     resetDuplicateSurveyModal()
  //   }

  //   if (survey_name === '') {
  //     setDuplicatingSurveyNameError(true)
  //     return
  //   } else {
  //     setDuplicatingSurveyNameError(false)
  //     const payload = {
  //       survey_id,
  //       survey_name,
  //       language_code: selectedLanguage ? selectedLanguage.value : null,
  //     }
  //     console.log("Selected Language:", selectedLanguage);
  //     console.log("Sending Payload:", payload);
  //     dispatch(duplicateSurvey(payload, successCallback))
  //   }
  // }

  const handleDuplicateSurvey = (survey_name, survey_id) => {
    if (isDuplicating) return;
    if (survey_name === "") {
      setDuplicatingSurveyNameError(true);
      return;
    }
    setDuplicatingSurveyNameError(false);

    const payload = {
      survey_id,
      survey_name,
      language_code: selectedLanguage ? selectedLanguage.value : null,
      added_by: userId,
    };

    setIsDuplicating(true);
    resetDuplicateSurveyModal();
    const toastId = toast.loading(t("survey.duplicate") + "...", { style: vfToastStyle, icon: vfToastIcon });

    const successCallback = () => {
      fetchPageData();
      setIsDuplicating(false);
      toast.dismiss(toastId);
      toast.success(t("sync.toast.surveyDuplicatedSuccess"));
    };
    const errorCallback = () => {
      setIsDuplicating(false);
      toast.dismiss(toastId);
      toast.error(t("sync.toast.surveyDuplicateFailed"));
    };
    dispatch(duplicateSurvey(payload, successCallback, errorCallback));
  };

  const moveToDraft = (surveyId) => {
    const successCallback = () => {
      fetchPageData();
    };
    let dataToSend = {
      val: "2",
      survey_id: surveyId,
    };
    dispatch(moveToDraftSurvey(dataToSend, successCallback));
  };

  const moveToPublish = (surveyId) => {
    const successCallback = () => {
      fetchPageData();
    };
    let dataToSend = {
      val: "1",
      survey_id: surveyId,
    };
    dispatch(moveToPublishSurvey(dataToSend, successCallback));
  };

  const handleAssignSurvey = () => {
    // If no team is selected, show error
    if (!selectedLTeam) {
      setAssignSurveyNameError(true);
      return;
    }

    // Build payload
    const payload = {
      survey_id: assignSurveyId,
      team_id: selectedLTeam.value,
    };

    console.log("payload-assigned to-", payload);

    // Dispatch addSurveyAssignTo action
    dispatch(addSurveyAssignTo(payload));

    // Close modal
    resetAssignSurveyModal();
    fetchPageData();
  };

  //Pagination
  const handlePageChange = (p) => {
    setPage(p);
  };

  const handlePerRowsChange = async (newPerPage, p) => {
    setPerPage(newPerPage);
    setPage(p);
  };

  const handleSort = (column, sortDirection) => {
    const columnToDatabase = {
      "Survey Name": "su_survey_title",
      Status: "su_is_active",
      "Added on": "su_survey_add_date_time",
      "Last modified": "su_survey_modified_date_time",
      "Published on": "su_survey_modified_date_time",
    };
    setSortby(columnToDatabase[column.name]);
    setSort(sortDirection.toUpperCase());
  };

  const fetchPageData = () => {
    if (userId) {
      const payload = {
        user_id: userId,
        perPage: perPage ?? 10,
        page: page ?? 1,
        sort: sort ?? "DESC",
        sortby: sortby ?? "su_survey_modified_date_time",
        search: filters.search,
        status: filters.status,
        su_languages: filters.language,
      };
      console.log(payload, "payload---");
      dispatch(getSurveyList(payload));
    }
  };

  //Modal
  const handleDuplicateSurveyModalOpen = (surveyId) => {
    setDuplicatingSurveyId(surveyId);
    setIsDuplicateSurveyModalOpen(true);
  };

  const handleAssignModalOpen = (surveyId) => {
    dispatch(getSurveyAssignTo(surveyId));
    setAssignSurveyId(surveyId);
    setIsAssignModalOpen(true);
  };

  const resetAssignSurveyModal = () => {
    setIsAssignModalOpen(false);
    setAssignSurveyId(null);
    setSelectedTeam(null);
    setAssignSurveyName("");
    setAssignSurveyNameError(false);
  };

  const resetDuplicateSurveyModal = () => {
    setIsDuplicateSurveyModalOpen(false);
    setDuplicatingSurveyName("");
    setDuplicatingSurveyNameError(false);
    setDuplicatingSurveyId(null);
    setSelectedLanguage(null);
  };

  const handleClear = () => {
    setDuplicatingSurveyName("");
    setDuplicatingSurveyNameError(false);
    setSelectedLanguage(null);
  };

  //Others
  const handleChangeSurveyName = (e) => {
    const value = e.target.value;
    if (value === "") {
      setDuplicatingSurveyNameError(true);
      setDuplicatingSurveyName(value);
    } else {
      setDuplicatingSurveyNameError(false);
      setDuplicatingSurveyName(value);
    }
  };

  //==> Effects <==
  useEffect(() => {
    fetchPageData();
  }, [filters, page, perPage, userId, sort, sortby, refreshKey]);

  //TODO need to make middleware
  // const checkToken = async (token_id) => {
  //   fetch(process.env.REACT_APP_NODE_API_URL+`/auth/getTokenData?token_id=`+token_id)
  //     .then(res => res.json())
  //     .then(
  //       (result) => {
  //         console.log(result);
  //         setuserId(result.id);
  //         fetchData();
  //       },
  //       (error) => {
  //         console.log(error);
  //         alert("token not verified, or expired, Login Again");
  //         window.location = '/';
  //       }
  //     )
  // }

  useEffect(() => {
    // If no data, do nothing
    if (!surveyAssignToData || surveyAssignToData.length === 0) {
      setSelectedTeam(null);
      return;
    }

    // We assume there's only 1 assignment per survey
    const assigned = surveyAssignToData[0];

    // Find the matching team in your `teamList`
    const foundTeam = teamList.find(
      (team) => team.team_id === assigned.team_id,
    );

    // If found, set as selected
    if (foundTeam) {
      setSelectedTeam({
        value: foundTeam.team_id,
        label: foundTeam.team_name,
      });
    } else {
      // If no matching team found, clear selection
      setSelectedTeam(null);
    }
  }, [surveyAssignToData, teamList]);

  // Handle row selection
  const handleRowSelected = (state) => {
    setSelectedRows(state.selectedRows);
    // Pass selected rows to parent component
    if (onSelectedRowsChange) {
      onSelectedRowsChange(state.selectedRows);
    }
  };

  const handleClearSelected = () => {
    setToggleCleared(!toggleCleared);
    setSelectedRows([]);
  };

  // Conditional row styles to add class to selected rows
  const conditionalRowStyles = [
    {
      when: (row) => {
        return selectedRows.some(
          (selectedRow) => selectedRow.survey_id === row.survey_id,
        );
      },
      classNames: ["row-selected"],
    },
  ];

  return (
    <div className="data-table-wrap custom-data-table">
      <DataTable
        title=""
        columns={columns}
        data={surveyList ?? []}
        defaultSortFieldID={1}
        onSort={handleSort}
        pagination
        paginationServer
        progressPending={loading}
        paginationTotalRows={totalRecords}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        selectableRows
        selectableRowsHighlight
        onSelectedRowsChange={handleRowSelected}
        clearSelectedRows={toggleCleared}
        conditionalRowStyles={conditionalRowStyles}
      />

      <div
        className="customvar-modal modal setting-modal custom-modal fade"
        id="languageListModal"
        tabIndex={-1}
        aria-labelledby="languageListModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div className={"survey-modal-wrapper" + " " + style.wrapper}>
                  <Card
                    view="raised"
                    className={"formstyle p-4 pb-1" + " " + style.card}
                  >
                    <div className="modal-heading">
                      <div className="d-flex align-items-start">
                        <div className="flex-grow-1">
                          <h4>Network Maturity Assessment</h4>
                          <p>5 Sections, 14 Questions </p>
                        </div>
                        <div className="action-wrapper d-flex align-items-center">
                          <div className="dropdown table-dropdown">
                            <button
                              className="btn dropdown-tgl"
                              type="button"
                              id="viewoptions"
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <svg
                                width={30}
                                height={30}
                                viewBox="0 0 30 30"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle
                                  cx={24}
                                  cy={15}
                                  r="2.5"
                                  transform="rotate(90 24 15)"
                                  fill="#0F2744"
                                />
                                <circle
                                  cx={15}
                                  cy={15}
                                  r="2.5"
                                  transform="rotate(90 15 15)"
                                  fill="#0F2744"
                                />
                                <circle
                                  cx={6}
                                  cy={15}
                                  r="2.5"
                                  transform="rotate(90 6 15)"
                                  fill="#0F2744"
                                />
                              </svg>
                            </button>
                            <div
                              className="dropdown-menu"
                              aria-labelledby="viewoptions"
                            >
                              <a className="dropdown-item d-flex align-items-center">
                                <div className="icon-circle me-3">
                                  <Svg name="Edit-Survey" />
                                </div>
                                <span className="dropdown-item">
                                  Edit Survey
                                </span>
                              </a>
                              <a
                                className="dropdown-item d-flex align-items-center"
                                href="#0"
                              >
                                <div className="icon-circle me-3">
                                  <Svg name="share" />
                                </div>
                                <span className="dropdown-item">
                                  Share Survey
                                </span>
                              </a>
                              <a
                                className="dropdown-item d-flex align-items-center"
                                href="#0"
                              >
                                <div className="icon-circle me-3">
                                  <Svg name="viewReport" />
                                </div>
                                <span className="dropdown-item">
                                  View Results
                                </span>
                              </a>

                              <a
                                className="dropdown-item d-flex align-items-center"
                                href="#0"
                              >
                                <div className="icon-circle me-3">
                                  <Svg name="duplicate" />
                                </div>
                                <span className="dropdown-item">Duplicate</span>
                              </a>

                              <a className="dropdown-item d-flex align-items-center">
                                <div className="icon-circle me-3">
                                  <Svg name="delete" />
                                </div>
                                <span className="dropdown-item">
                                  {t("settings.roles.delete_action.delete")}
                                </span>
                              </a>
                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn btn-cancel"
                            data-bs-dismiss="modal"
                          >
                            <svg
                              width={19}
                              height={21}
                              viewBox="0 0 19 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1 1L17 17"
                                stroke="#0F2744"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                              />
                              <path
                                d="M17 1L1 17"
                                stroke="#0F2744"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="info-wrapper">
                      <div className="general-info">
                        <h5>GENERAL INFORMATION</h5>
                        <div className="info-data">
                          <div className="d-flex data-title">
                            <div className="flex-grow-1 title">Responses</div>
                            <div className="data">45</div>
                          </div>
                          <div className="d-flex data-title">
                            <div className="flex-grow-1 title">Completion</div>
                            <div className="data">50%</div>
                          </div>
                          <div className="d-flex data-title">
                            <div className="flex-grow-1 title">Status</div>
                            <div className="data">Active</div>
                          </div>
                          <div className="d-flex data-title">
                            <div className="flex-grow-1 title">Added on</div>
                            <div className="data">18/11/22</div>
                          </div>
                          <div className="d-flex data-title">
                            <div className="flex-grow-1 title">
                              Last modified
                            </div>
                            <div className="data">2 mins ago</div>
                          </div>
                          <div className="d-flex data-title">
                            <div className="flex-grow-1 title">
                              Published on
                            </div>
                            <div className="data">22/11/22</div>
                          </div>
                        </div>
                      </div>
                      <div className="setting-info">
                        <h5>GENERAL INFORMATION</h5>
                        <div className="info-data">
                          <div className="d-flex data-title">
                            <div className="flex-grow-1 title">Languages</div>
                            <div className="data">
                              <span className="language">Spanish</span>
                              <span className="language">Indonesian</span>
                              <span className="language">Mandarin</span>
                              <span className="language">French</span>
                            </div>
                          </div>
                          <div className="d-flex data-title">
                            <div className="flex-grow-1 title">
                              Limit submissions per user
                            </div>
                            <div className="data">On</div>
                          </div>
                          <div className="d-flex data-title">
                            <div className="flex-grow-1 title">
                              Set cut-off date
                            </div>
                            <div className="data">On</div>
                          </div>
                          <div className="d-flex data-title">
                            <div className="flex-grow-1 title">
                              Allow users to send a copy of response to
                              themselves
                            </div>
                            <div className="data">On</div>
                          </div>
                          <div className="d-flex data-title">
                            <div className="flex-grow-1 title">
                              Notifications
                            </div>
                            <div className="data">On</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`customvar-modal modal custom-modal fade deleteModal ${isDuplicateSurveyModalOpen ? "show" : ""}`}
        style={{ display: `${isDuplicateSurveyModalOpen ? "block" : "none"}` }}
        id="duplicateSurveyModal"
        tabIndex={-1}
        aria-labelledby="duplicate-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div
                  className={
                    "formvawrapper delete-modal-wrap modal-setting-medium" +
                    " " +
                    style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-0" + " " + style.card}
                  >
                    <div className="delete-body-wrap delete-language">
                      <div className="heading">
                        <h3>{t("survey.duplicate")}</h3>
                      </div>
                      <div className="mb-3 position-relative">
                        <label className="form-label-custom">
                          {t("survey.surveyName")}
                        </label>
                        <Input
                          type="text"
                          view="outlined"
                          dense={false}
                          color="default"
                          label=""
                          placeholder={t("survey.enter")}
                          clearButton={true}
                          success={false}
                          error={false}
                          fill={true}
                          errorHelperText={null}
                          className={"formsinput"}
                          value={duplicatingSurveyName}
                          onChange={(e) => {
                            handleChangeSurveyName(e);
                          }}
                          onClear={() => handleClear()}
                        />
                        {duplicatingSurveyNameError && (
                          <div className="validation-msg">
                            {t("survey.enter")}
                          </div>
                        )}
                      </div>

                      <div className="mb-3 mb-md-4 position-relative cstom-select">
                        <label className="form-label-custom">
                          {t("survey.language")}
                        </label>
                        <Select
                          //placeholder={t('settings.account_settings.default_language')}
                          options={languageList?.result?.map((lang) => ({
                            value: lang.su_language_id,
                            label: lang.su_language_name,
                          }))}
                          value={selectedLanguage} // Set selected language
                          onChange={(selectedOption) =>
                            setSelectedLanguage(selectedOption)
                          }
                          placeholder={t("survey.select")}
                        />
                      </div>
                      <div className="button-wrap d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-primary"
                          disabled={isDuplicating}
                          onClick={() =>
                            handleDuplicateSurvey(
                              duplicatingSurveyName,
                              duplicatingSurveyId,
                            )
                          }
                        >
                          {isDuplicating ? (
                            <span className="d-inline-flex align-items-center gap-2">
                              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                              {t("settings.team.create_team.save")}...
                            </span>
                          ) : t("settings.team.create_team.save")}
                        </button>
                        <button
                          type="button"
                          className="btn btn-bordered ms-3"
                          disabled={isDuplicating}
                          onClick={() => resetDuplicateSurveyModal()}
                        >
                          {t("survey.customVariable.cancel")}
                        </button>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {Assign to} */}

      <div
        className={`customvar-modal modal custom-modal fade deleteModal ${isAssignModalOpen ? "show" : ""}`}
        style={{ display: `${isAssignModalOpen ? "block" : "none"}` }}
        id="assignToSurveyModal"
        tabIndex={-1}
        aria-labelledby="assignto-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div
                  className={
                    "formvawrapper delete-modal-wrap modal-setting-medium" +
                    " " +
                    style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-0" + " " + style.card}
                  >
                    <div className="delete-body-wrap delete-language">
                      <div className="heading">
                        <h3>{t("survey.assignTO")}</h3>
                      </div>
                      <div className="cstom-select position-relative mb-4">
                        <Select
                          //placeholder={t('settings.account_settings.default_language')}
                          options={teamList.map((team) => ({
                            value: team.team_id,
                            label: team.team_name,
                          }))}
                          value={selectedLTeam} // Set selected language
                          onChange={(selectedOption) =>
                            setSelectedTeam(selectedOption)
                          }
                          placeholder={t("survey.select")}
                        />
                      </div>
                      <div className="button-wrap d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleAssignSurvey}
                        >
                          {t("settings.team.create_team.save")}
                        </button>
                        <button
                          type="button"
                          className="btn btn-bordered ms-3"
                          onClick={() => resetAssignSurveyModal()}
                        >
                          {t("survey.customVariable.cancel")}
                        </button>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sync Options Modal */}
      <div
        className={`customvar-modal modal custom-modal fade deleteModal ${isSyncOptionsModalOpen ? "show" : ""}`}
        style={{ display: `${isSyncOptionsModalOpen ? "block" : "none"}` }}
        id="syncOptionsModal"
        tabIndex={-1}
        aria-labelledby="syncOptionsModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div
                  className={
                    "formvawrapper delete-modal-wrap modal-setting-medium" +
                    " " +
                    style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-0" + " " + style.card}
                  >
                    <div className="delete-body-wrap delete-language">
                      <div className="heading">
                        <h3>{t("sync.syncFromUat")}</h3>
                        <p className="mb-0">
                          {t("sync.survey")}:{" "}
                          <strong>{syncTargetSurvey?.name || "-"}</strong>
                        </p>
                      </div>

                      <div className="mb-3">
                        <label className="form-label-custom">
                          {t("sync.mode")}
                        </label>
                        <div className="d-flex flex-column gap-2">
                          <label className="d-flex align-items-center gap-2">
                            <input
                              type="radio"
                              name="syncMode"
                              checked={syncMode === "full"}
                              onChange={() => setSyncMode("full")}
                              disabled={isSyncing}
                            />
                            <span>{t("sync.fullReplacement")}</span>
                          </label>

                          <label className="d-flex align-items-center gap-2">
                            <input
                              type="radio"
                              name="syncMode"
                              checked={syncMode === "merge"}
                              onChange={() => setSyncMode("merge")}
                              disabled={isSyncing}
                            />
                            <span>{t("sync.merge")}</span>
                          </label>
                        </div>
                      </div>

                      {/* Version info message for Full Replacement */}
                      {syncMode === "full" && (
                        <div
                          className="alert alert-info mb-3"
                          style={{ fontSize: "13px", padding: "10px" }}
                        >
                          <strong>{t("sync.noteLabel")}</strong>{" "}
                          {t("sync.fullReplacementNote")}
                        </div>
                      )}

                      {/* Merge mode info */}
                      {syncMode === "merge" && (
                        <div
                          className="alert alert-warning mb-3"
                          style={{ fontSize: "13px", padding: "10px" }}
                        >
                          <strong>{t("sync.mergeModeLabel")}</strong>{" "}
                          {t("sync.mergeNote")}
                        </div>
                      )}

                      <div className="button-wrap d-flex justify-content-end">
                        {/* Merge Mode: Show only "Next" and "Cancel" */}
                        {syncMode === "merge" ? (
                          <>
                            <button
                              type="button"
                              className="btn btn-bordered"
                              onClick={resetSyncOptionsModal}
                              disabled={mergePreviewLoading}
                            >
                              {t("sync.cancel")}
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary ms-3"
                              onClick={handlePreviewClick}
                              disabled={mergePreviewLoading}
                            >
                              {mergePreviewLoading
                                ? t("sync.loading")
                                : t("sync.next")}
                            </button>
                          </>
                        ) : (
                          /* Full Replacement Mode: Show "Cancel" and "Sync" */
                          <>
                            <button
                              type="button"
                              className="btn btn-bordered"
                              onClick={resetSyncOptionsModal}
                              disabled={isSyncing}
                            >
                              {t("sync.cancel")}
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary ms-3"
                              onClick={handleSyncClick}
                              disabled={isSyncing}
                            >
                              {isSyncing ? t("sync.syncing") : t("sync.sync")}
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Version History Modal (Rollback UI only) */}
      <div
        className={`customvar-modal modal custom-modal fade deleteModal ${isVersionHistoryModalOpen ? "show" : ""}`}
        style={{ display: `${isVersionHistoryModalOpen ? "block" : "none"}` }}
        id="versionHistoryModal"
        tabIndex={-1}
        aria-labelledby="versionHistoryModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div
                  className={
                    "formvawrapper delete-modal-wrap" + " " + style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-0" + " " + style.card}
                  >
                    <div
                      className="delete-body-wrap delete-language"
                      style={{ padding: "24px" }}
                    >
                      <div className="heading" style={{ marginBottom: "20px" }}>
                        <h3
                          style={{
                            marginBottom: "8px",
                            fontSize: "20px",
                            fontWeight: "600",
                          }}
                        >
                          {t("sync.versionHistory")}
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "400",
                              color: "#9ca3af",
                              marginLeft: "12px",
                            }}
                          >
                            {t("sync.showLatestVersions")}
                          </span>
                        </h3>
                        <p
                          className="mb-0"
                          style={{ fontSize: "14px", color: "#6c757d" }}
                        >
                          {t("sync.survey")}:{" "}
                          <strong style={{ color: "#0F2744" }}>
                            {syncTargetSurvey?.name || "-"}
                          </strong>
                        </p>
                      </div>

                      {versionHistoryError ? (
                        <div
                          className="alert alert-danger mb-3"
                          style={{ fontSize: "13px", padding: "10px" }}
                        >
                          {versionHistoryError}
                        </div>
                      ) : null}

                      <div
                        className="table-responsive mb-3"
                        style={{ maxHeight: 360, overflow: "auto" }}
                      >
                        <table className="table table-sm table-hover">
                          <thead
                            style={{
                              position: "sticky",
                              top: 0,
                              backgroundColor: "#fff",
                              zIndex: 1,
                            }}
                          >
                            <tr>
                              <th
                                style={{
                                  width: 90,
                                  borderBottom: "2px solid #dee2e6",
                                }}
                              >
                                {t("sync.version")}
                              </th>
                              <th style={{ borderBottom: "2px solid #dee2e6" }}>
                                {t("sync.type")}
                              </th>
                              <th
                                style={{
                                  width: 110,
                                  borderBottom: "2px solid #dee2e6",
                                }}
                              >
                                {t("sync.date")}
                              </th>
                              <th
                                style={{
                                  width: 90,
                                  textAlign: "right",
                                  borderBottom: "2px solid #dee2e6",
                                }}
                              >
                                {t("sync.action")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {versionHistoryLoading ? (
                              <tr>
                                <td colSpan={4} style={{ padding: 12 }}>
                                  {t("sync.loadingVersions")}
                                </td>
                              </tr>
                            ) : (
                              (() => {
                                // Show latest 5 versions (limited by backend)
                                const versions = versionHistoryRows || [];
                                return versions && versions.length > 0 ? (
                                  versions.map((v) => {
                                    const versionNumber =
                                      v?.version_number ?? "-";
                                    const createdAt = v?.created_at
                                      ? moment(v.created_at).format(
                                          "DD-MM-YYYY",
                                        )
                                      : "-";
                                    const versionLabel = v?.version_label || "";

                                    // Determine type based on label
                                    const isMergeBackup = versionLabel
                                      .toLowerCase()
                                      .includes("merge");
                                    const isRestoreBackup = versionLabel
                                      .toLowerCase()
                                      .includes("restore");
                                    // Extract "v3" from "Pre-restore backup (before restoring v3)"
                                    const restoreTargetMatch =
                                      versionLabel.match(/restoring\s+v(\d+)/i);
                                    const restoreTargetVersion =
                                      restoreTargetMatch
                                        ? restoreTargetMatch[1]
                                        : null;

                                    return (
                                      <tr
                                        key={
                                          v?.version_id ||
                                          `${versionNumber}-${createdAt}`
                                        }
                                      >
                                        <td
                                          style={{ fontWeight: 600 }}
                                        >{`V${versionNumber}`}</td>
                                        <td>
                                          {isRestoreBackup ? (
                                            restoreTargetVersion ? (
                                              <span
                                                style={{ color: "#856404" }}
                                              >
                                                {t(
                                                  "sync.beforeRestoreToVersion",
                                                )}{" "}
                                                {restoreTargetVersion}
                                              </span>
                                            ) : (
                                              <span
                                                style={{ color: "#856404" }}
                                              >
                                                {t("sync.beforeRestore")}
                                              </span>
                                            )
                                          ) : isMergeBackup ? (
                                            <span
                                              style={{
                                                color: "#0d6efd",
                                                fontWeight: 500,
                                              }}
                                            >
                                              {t("sync.beforeMerge")}
                                            </span>
                                          ) : (
                                            <span style={{ color: "#0f5132" }}>
                                              {t("sync.beforeSync")}
                                            </span>
                                          )}
                                        </td>
                                        <td>{createdAt}</td>
                                        <td style={{ textAlign: "right" }}>
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            disabled={
                                              restoringVersionId !== null
                                            }
                                            onClick={() => handleRestore(v)}
                                            style={{
                                              fontSize: "12px",
                                              padding: "3px 10px",
                                            }}
                                          >
                                            {restoringVersionId ===
                                            v?.version_id
                                              ? t("sync.restoring")
                                              : t("sync.restore")}
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={4}
                                      style={{
                                        padding: 12,
                                        textAlign: "center",
                                        color: "#6c757d",
                                      }}
                                    >
                                      {t("sync.noVersionsFound")}
                                    </td>
                                  </tr>
                                );
                              })()
                            )}
                          </tbody>
                        </table>
                      </div>

                      <div
                        className="button-wrap d-flex justify-content-end"
                        style={{ marginTop: "20px", paddingTop: "20px" }}
                      >
                        <button
                          type="button"
                          className="btn btn-bordered"
                          onClick={resetVersionHistoryModal}
                          style={{ padding: "8px 24px" }}
                        >
                          {t("sync.close")}
                        </button>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Merge Preview Modal */}
      <div
        className={`customvar-modal modal custom-modal fade deleteModal ${isMergePreviewModalOpen ? "show" : ""}`}
        style={{ display: `${isMergePreviewModalOpen ? "block" : "none"}` }}
        id="mergePreviewModal"
        tabIndex={-1}
        aria-labelledby="mergePreviewModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer p-0" + " " + style.container}>
                <div
                  className={
                    "formvawrapper full-width-popup delete-modal-wrap" +
                    " " +
                    style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-0" + " " + style.card}
                  >
                    <div
                      className="delete-body-wrap delete-language"
                      style={{ padding: "24px" }}
                    >
                      <div className="heading" style={{ marginBottom: "20px" }}>
                        <h3
                          style={{
                            marginBottom: "8px",
                            fontSize: "20px",
                            fontWeight: "600",
                          }}
                        >
                          {t("sync.mergePreview")}
                        </h3>
                        <p
                          className="mb-0"
                          style={{ fontSize: "14px", color: "#6c757d" }}
                        >
                          {t("sync.survey")}:{" "}
                          <strong style={{ color: "#0F2744" }}>
                            {syncTargetSurvey?.name || "-"}
                          </strong>
                        </p>
                      </div>

                      {/* Summary */}
                      {mergePreviewData && (
                        <div className="mb-3">
                          {/* Removed Primary/UAT counters + After Merge summary (per request) */}

                          {/* Changes Summary Banner */}
                          {(() => {
                            // Calculate NEW items count
                            const uiNew =
                              (mergePreviewData.questions?.new?.length || 0) +
                              (mergePreviewData.sections?.new?.length || 0) +
                              (mergePreviewData.variables?.new?.length || 0) +
                              (mergePreviewData.leadGenVars?.new?.length || 0) +
                              (mergePreviewData.utmVars?.new?.length || 0) +
                              (mergePreviewData.customFormulas?.new?.length ||
                                0) +
                              (mergePreviewData.stages?.new?.length || 0) +
                              (mergePreviewData.reportPages?.new?.length || 0) +
                              (mergePreviewData.customVarValues?.new?.length ||
                                0) +
                              (mergePreviewData.reports?.new_count || 0) +
                              (mergePreviewData.surveyLinks?.new_count || 0) +
                              (mergePreviewData.webhooks?.new_count || 0) +
                              (mergePreviewData.privacyPolicies?.new_count ||
                                0) +
                              (mergePreviewData.landingPages?.new_count || 0);

                            // Calculate CONFLICTS count
                            const uiConflicts =
                              (mergePreviewData.questions?.conflicts?.length ||
                                0) +
                              (mergePreviewData.sections?.conflicts?.length ||
                                0) +
                              (mergePreviewData.variables?.conflicts?.length ||
                                0) +
                              (mergePreviewData.leadGenVars?.conflicts
                                ?.length || 0) +
                              (mergePreviewData.utmVars?.conflicts?.length ||
                                0) +
                              (mergePreviewData.customFormulas?.conflicts
                                ?.length || 0) +
                              (mergePreviewData.stages?.conflicts?.length ||
                                0) +
                              (mergePreviewData.reportPages?.conflicts
                                ?.length || 0) +
                              (mergePreviewData.customVarValues?.conflicts
                                ?.length || 0) +
                              (mergePreviewData.reports?.conflicts_count || 0) +
                              (mergePreviewData.surveyLinks?.conflicts_count ||
                                0) +
                              (mergePreviewData.webhooks?.conflicts_count ||
                                0) +
                              (mergePreviewData.privacyPolicies
                                ?.conflicts_count || 0) +
                              (mergePreviewData.questionnaire
                                ?.conflicts_count || 0) +
                              (mergePreviewData.thankYouPage?.conflicts_count ||
                                0);

                            // Don't show banner if no changes
                            if (!uiNew && !uiConflicts) return null;

                            // Build message parts
                            const parts = [];
                            if (uiNew > 0)
                              parts.push(`${uiNew} ${t("sync.newItems")}`);
                            if (uiConflicts > 0)
                              parts.push(
                                `${uiConflicts} ${t("sync.conflictsWarning")}`,
                              );

                            // Determine banner style based on content
                            const hasConflicts = uiConflicts > 0;
                            const bgColor = hasConflicts
                              ? "#fff3cd"
                              : "#d1e7dd";
                            const borderColor = hasConflicts
                              ? "#ffc107"
                              : "#198754";
                            const icon = hasConflicts ? "⚠" : "✓";

                            return (
                              <div
                                className="alert mb-3"
                                style={{
                                  fontSize: "13px",
                                  padding: "12px",
                                  background: bgColor,
                                  border: `1px solid ${borderColor}`,
                                  borderRadius: "4px",
                                }}
                              >
                                <strong>
                                  {icon} {parts.join(", ")}
                                </strong>
                                {hasConflicts && (
                                  <span style={{ marginLeft: "8px" }}>
                                    - {t("sync.conflictsDescription")}
                                  </span>
                                )}
                              </div>
                            );
                          })()}

                          {/* Scrollable Content Area - Simple counters for UUID-based components */}
                          <div
                            style={{
                              maxHeight: 450,
                              overflowY: "auto",
                              overflowX: "hidden",
                            }}
                            className="mb-3"
                          >
                            <div
                              className="row g-2"
                              style={{ fontSize: "12px" }}
                            >
                              <div className="col-12 col-md-6">
                                <div
                                  style={{
                                    padding: "8px 10px",
                                    border: `1px solid ${(mergePreviewData.questions?.conflicts?.length || 0) > 0 ? "#ffeeba" : (mergePreviewData.questions?.new?.length || 0) > 0 ? "#badbcc" : "#e9ecef"}`,
                                    borderRadius: "4px",
                                    background:
                                      (mergePreviewData.questions?.conflicts
                                        ?.length || 0) > 0
                                        ? "#fff3cd"
                                        : (mergePreviewData.questions?.new
                                              ?.length || 0) > 0
                                          ? "#d1e7dd"
                                          : "#f8f9fa",
                                  }}
                                >
                                  <div style={{ fontWeight: 600 }}>
                                    {t("sync.questions")}
                                  </div>
                                  <div style={{ color: "#6c757d" }}>
                                    {t("sync.new")}:{" "}
                                    {mergePreviewData.questions?.new?.length ||
                                      0}{" "}
                                    | {t("sync.conflicts")}:{" "}
                                    {mergePreviewData.questions?.conflicts
                                      ?.length || 0}
                                    {(mergePreviewData.questions?.duplicates
                                      ?.length || 0) > 0
                                      ? ` | ${t("sync.duplicates")}: ${mergePreviewData.questions.duplicates.length}`
                                      : ""}
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 col-md-6">
                                <div
                                  style={{
                                    padding: "8px 10px",
                                    border: `1px solid ${(mergePreviewData.sections?.conflicts?.length || 0) > 0 ? "#ffeeba" : (mergePreviewData.sections?.new?.length || 0) > 0 ? "#badbcc" : "#e9ecef"}`,
                                    borderRadius: "4px",
                                    background:
                                      (mergePreviewData.sections?.conflicts
                                        ?.length || 0) > 0
                                        ? "#fff3cd"
                                        : (mergePreviewData.sections?.new
                                              ?.length || 0) > 0
                                          ? "#d1e7dd"
                                          : "#f8f9fa",
                                  }}
                                >
                                  <div style={{ fontWeight: 600 }}>
                                    {t("sync.sections")}
                                  </div>
                                  <div style={{ color: "#6c757d" }}>
                                    {t("sync.new")}:{" "}
                                    {mergePreviewData.sections?.new?.length ||
                                      0}{" "}
                                    | {t("sync.conflicts")}:{" "}
                                    {mergePreviewData.sections?.conflicts
                                      ?.length || 0}
                                    {(mergePreviewData.sections?.duplicates
                                      ?.length || 0) > 0
                                      ? ` | ${t("sync.duplicates")}: ${mergePreviewData.sections.duplicates.length}`
                                      : ""}
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 col-md-6">
                                <div
                                  style={{
                                    padding: "8px 10px",
                                    border: `1px solid ${(mergePreviewData.variables?.conflicts?.length || 0) > 0 ? "#ffeeba" : (mergePreviewData.variables?.new?.length || 0) > 0 ? "#badbcc" : "#e9ecef"}`,
                                    borderRadius: "4px",
                                    background:
                                      (mergePreviewData.variables?.conflicts
                                        ?.length || 0) > 0
                                        ? "#fff3cd"
                                        : (mergePreviewData.variables?.new
                                              ?.length || 0) > 0
                                          ? "#d1e7dd"
                                          : "#f8f9fa",
                                  }}
                                >
                                  <div style={{ fontWeight: 600 }}>
                                    {t("sync.variables")}
                                  </div>
                                  <div style={{ color: "#6c757d" }}>
                                    {t("sync.new")}:{" "}
                                    {mergePreviewData.variables?.new?.length ||
                                      0}{" "}
                                    | {t("sync.conflicts")}:{" "}
                                    {mergePreviewData.variables?.conflicts
                                      ?.length || 0}
                                    {(mergePreviewData.variables?.duplicates
                                      ?.length || 0) > 0
                                      ? ` | ${t("sync.duplicates")}: ${mergePreviewData.variables.duplicates.length}`
                                      : ""}
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 col-md-6">
                                <div
                                  style={{
                                    padding: "8px 10px",
                                    border: `1px solid ${(mergePreviewData.leadGenVars?.conflicts?.length || 0) > 0 ? "#ffeeba" : (mergePreviewData.leadGenVars?.new?.length || 0) > 0 ? "#badbcc" : "#e9ecef"}`,
                                    borderRadius: "4px",
                                    background:
                                      (mergePreviewData.leadGenVars?.conflicts
                                        ?.length || 0) > 0
                                        ? "#fff3cd"
                                        : (mergePreviewData.leadGenVars?.new
                                              ?.length || 0) > 0
                                          ? "#d1e7dd"
                                          : "#f8f9fa",
                                  }}
                                >
                                  <div style={{ fontWeight: 600 }}>
                                    {t("sync.leadGenVariables")}
                                  </div>
                                  <div style={{ color: "#6c757d" }}>
                                    {t("sync.new")}:{" "}
                                    {mergePreviewData.leadGenVars?.new
                                      ?.length || 0}{" "}
                                    | {t("sync.conflicts")}:{" "}
                                    {mergePreviewData.leadGenVars?.conflicts
                                      ?.length || 0}
                                    {(mergePreviewData.leadGenVars?.duplicates
                                      ?.length || 0) > 0
                                      ? ` | ${t("sync.duplicates")}: ${mergePreviewData.leadGenVars.duplicates.length}`
                                      : ""}
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 col-md-6">
                                <div
                                  style={{
                                    padding: "8px 10px",
                                    border: `1px solid ${(mergePreviewData.utmVars?.conflicts?.length || 0) > 0 ? "#ffeeba" : (mergePreviewData.utmVars?.new?.length || 0) > 0 ? "#badbcc" : "#e9ecef"}`,
                                    borderRadius: "4px",
                                    background:
                                      (mergePreviewData.utmVars?.conflicts
                                        ?.length || 0) > 0
                                        ? "#fff3cd"
                                        : (mergePreviewData.utmVars?.new
                                              ?.length || 0) > 0
                                          ? "#d1e7dd"
                                          : "#f8f9fa",
                                  }}
                                >
                                  <div style={{ fontWeight: 600 }}>
                                    {t("sync.utmVariables")}
                                  </div>
                                  <div style={{ color: "#6c757d" }}>
                                    {t("sync.new")}:{" "}
                                    {mergePreviewData.utmVars?.new?.length || 0}{" "}
                                    | {t("sync.conflicts")}:{" "}
                                    {mergePreviewData.utmVars?.conflicts
                                      ?.length || 0}
                                    {(mergePreviewData.utmVars?.duplicates
                                      ?.length || 0) > 0
                                      ? ` | ${t("sync.duplicates")}: ${mergePreviewData.utmVars.duplicates.length}`
                                      : ""}
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 col-md-6">
                                <div
                                  style={{
                                    padding: "8px 10px",
                                    border: `1px solid ${(mergePreviewData.customFormulas?.conflicts?.length || 0) > 0 ? "#ffeeba" : (mergePreviewData.customFormulas?.new?.length || 0) > 0 ? "#badbcc" : "#e9ecef"}`,
                                    borderRadius: "4px",
                                    background:
                                      (mergePreviewData.customFormulas
                                        ?.conflicts?.length || 0) > 0
                                        ? "#fff3cd"
                                        : (mergePreviewData.customFormulas?.new
                                              ?.length || 0) > 0
                                          ? "#d1e7dd"
                                          : "#f8f9fa",
                                  }}
                                >
                                  <div style={{ fontWeight: 600 }}>
                                    {t("sync.customFormulas")}
                                  </div>
                                  <div style={{ color: "#6c757d" }}>
                                    {t("sync.new")}:{" "}
                                    {mergePreviewData.customFormulas?.new
                                      ?.length || 0}{" "}
                                    | {t("sync.conflicts")}:{" "}
                                    {mergePreviewData.customFormulas?.conflicts
                                      ?.length || 0}
                                    {(mergePreviewData.customFormulas
                                      ?.duplicates?.length || 0) > 0
                                      ? ` | ${t("sync.duplicates")}: ${mergePreviewData.customFormulas.duplicates.length}`
                                      : ""}
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 col-md-6">
                                <div
                                  style={{
                                    padding: "8px 10px",
                                    border: `1px solid ${(mergePreviewData.stages?.conflicts?.length || 0) > 0 ? "#ffeeba" : (mergePreviewData.stages?.new?.length || 0) > 0 ? "#badbcc" : "#e9ecef"}`,
                                    borderRadius: "4px",
                                    background:
                                      (mergePreviewData.stages?.conflicts
                                        ?.length || 0) > 0
                                        ? "#fff3cd"
                                        : (mergePreviewData.stages?.new
                                              ?.length || 0) > 0
                                          ? "#d1e7dd"
                                          : "#f8f9fa",
                                  }}
                                >
                                  <div style={{ fontWeight: 600 }}>
                                    {t("sync.stages")}
                                  </div>
                                  <div style={{ color: "#6c757d" }}>
                                    {t("sync.new")}:{" "}
                                    {mergePreviewData.stages?.new?.length || 0}{" "}
                                    | {t("sync.conflicts")}:{" "}
                                    {mergePreviewData.stages?.conflicts
                                      ?.length || 0}
                                    {(mergePreviewData.stages?.duplicates
                                      ?.length || 0) > 0
                                      ? ` | ${t("sync.duplicates")}: ${mergePreviewData.stages.duplicates.length}`
                                      : ""}
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 col-md-6">
                                <div
                                  style={{
                                    padding: "8px 10px",
                                    border: `1px solid ${(mergePreviewData.reportPages?.conflicts?.length || 0) > 0 ? "#ffeeba" : (mergePreviewData.reportPages?.new?.length || 0) > 0 ? "#badbcc" : "#e9ecef"}`,
                                    borderRadius: "4px",
                                    background:
                                      (mergePreviewData.reportPages?.conflicts
                                        ?.length || 0) > 0
                                        ? "#fff3cd"
                                        : (mergePreviewData.reportPages?.new
                                              ?.length || 0) > 0
                                          ? "#d1e7dd"
                                          : "#f8f9fa",
                                  }}
                                >
                                  <div style={{ fontWeight: 600 }}>
                                    {t("sync.reportPages")}
                                  </div>
                                  <div style={{ color: "#6c757d" }}>
                                    {t("sync.new")}:{" "}
                                    {mergePreviewData.reportPages?.new
                                      ?.length || 0}{" "}
                                    | {t("sync.conflicts")}:{" "}
                                    {mergePreviewData.reportPages?.conflicts
                                      ?.length || 0}
                                    {(mergePreviewData.reportPages?.duplicates
                                      ?.length || 0) > 0
                                      ? ` | ${t("sync.duplicates")}: ${mergePreviewData.reportPages.duplicates.length}`
                                      : ""}
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 col-md-6">
                                <div
                                  style={{
                                    padding: "8px 10px",
                                    border: `1px solid ${(mergePreviewData.customVarValues?.conflicts?.length || 0) > 0 ? "#ffeeba" : (mergePreviewData.customVarValues?.new?.length || 0) > 0 ? "#badbcc" : "#e9ecef"}`,
                                    borderRadius: "4px",
                                    background:
                                      (mergePreviewData.customVarValues
                                        ?.conflicts?.length || 0) > 0
                                        ? "#fff3cd"
                                        : (mergePreviewData.customVarValues?.new
                                              ?.length || 0) > 0
                                          ? "#d1e7dd"
                                          : "#f8f9fa",
                                  }}
                                >
                                  <div style={{ fontWeight: 600 }}>
                                    {t("sync.customVariableValues")}
                                  </div>
                                  <div style={{ color: "#6c757d" }}>
                                    {t("sync.new")}:{" "}
                                    {mergePreviewData.customVarValues?.new
                                      ?.length || 0}{" "}
                                    | {t("sync.conflicts")}:{" "}
                                    {mergePreviewData.customVarValues?.conflicts
                                      ?.length || 0}
                                    {(mergePreviewData.customVarValues
                                      ?.duplicates?.length || 0) > 0
                                      ? ` | ${t("sync.duplicates")}: ${mergePreviewData.customVarValues.duplicates.length}`
                                      : ""}
                                  </div>
                                </div>
                              </div>

                              {/* Keep these components in the same grid (no "Other Components" section) */}
                              <div className="col-12 col-md-6">
                                <div
                                  style={{
                                    padding: "8px 10px",
                                    border: `1px solid ${(mergePreviewData.reports?.conflicts_count || 0) > 0 ? "#ffeeba" : (mergePreviewData.reports?.new_count || 0) > 0 ? "#badbcc" : "#e9ecef"}`,
                                    borderRadius: "4px",
                                    background:
                                      (mergePreviewData.reports
                                        ?.conflicts_count || 0) > 0
                                        ? "#fff3cd"
                                        : (mergePreviewData.reports
                                              ?.new_count || 0) > 0
                                          ? "#d1e7dd"
                                          : "#f8f9fa",
                                  }}
                                >
                                  <div style={{ fontWeight: 600 }}>
                                    {t("sync.reports")}
                                  </div>
                                  <div style={{ color: "#6c757d" }}>
                                    {t("sync.new")}:{" "}
                                    {mergePreviewData.reports?.new_count || 0} |{" "}
                                    {t("sync.conflicts")}:{" "}
                                    {mergePreviewData.reports
                                      ?.conflicts_count || 0}
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 col-md-6">
                                <div
                                  style={{
                                    padding: "8px 10px",
                                    border: `1px solid ${(mergePreviewData.surveyLinks?.conflicts_count || 0) > 0 ? "#ffeeba" : (mergePreviewData.surveyLinks?.new_count || 0) > 0 ? "#badbcc" : "#e9ecef"}`,
                                    borderRadius: "4px",
                                    background:
                                      (mergePreviewData.surveyLinks
                                        ?.conflicts_count || 0) > 0
                                        ? "#fff3cd"
                                        : (mergePreviewData.surveyLinks
                                              ?.new_count || 0) > 0
                                          ? "#d1e7dd"
                                          : "#f8f9fa",
                                  }}
                                >
                                  <div style={{ fontWeight: 600 }}>
                                    {t("sync.surveyLinks")}
                                  </div>
                                  <div style={{ color: "#6c757d" }}>
                                    {t("sync.new")}:{" "}
                                    {mergePreviewData.surveyLinks?.new_count ||
                                      0}{" "}
                                    | {t("sync.conflicts")}:{" "}
                                    {mergePreviewData.surveyLinks
                                      ?.conflicts_count || 0}
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 col-md-6">
                                <div
                                  style={{
                                    padding: "8px 10px",
                                    border: `1px solid ${(mergePreviewData.webhooks?.conflicts_count || 0) > 0 ? "#ffeeba" : (mergePreviewData.webhooks?.new_count || 0) > 0 ? "#badbcc" : "#e9ecef"}`,
                                    borderRadius: "4px",
                                    background:
                                      (mergePreviewData.webhooks
                                        ?.conflicts_count || 0) > 0
                                        ? "#fff3cd"
                                        : (mergePreviewData.webhooks
                                              ?.new_count || 0) > 0
                                          ? "#d1e7dd"
                                          : "#f8f9fa",
                                  }}
                                >
                                  <div style={{ fontWeight: 600 }}>
                                    {t("sync.webhooks")}
                                  </div>
                                  <div style={{ color: "#6c757d" }}>
                                    {t("sync.new")}:{" "}
                                    {mergePreviewData.webhooks?.new_count || 0}{" "}
                                    | {t("sync.conflicts")}:{" "}
                                    {mergePreviewData.webhooks
                                      ?.conflicts_count || 0}
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 col-md-6">
                                <div
                                  style={{
                                    padding: "8px 10px",
                                    border: `1px solid ${(mergePreviewData.privacyPolicies?.conflicts_count || 0) > 0 ? "#ffeeba" : (mergePreviewData.privacyPolicies?.new_count || 0) > 0 ? "#badbcc" : "#e9ecef"}`,
                                    borderRadius: "4px",
                                    background:
                                      (mergePreviewData.privacyPolicies
                                        ?.conflicts_count || 0) > 0
                                        ? "#fff3cd"
                                        : (mergePreviewData.privacyPolicies
                                              ?.new_count || 0) > 0
                                          ? "#d1e7dd"
                                          : "#f8f9fa",
                                  }}
                                >
                                  <div style={{ fontWeight: 600 }}>
                                    {t("sync.privacyPolicy")}
                                  </div>
                                  <div style={{ color: "#6c757d" }}>
                                    {t("sync.new")}:{" "}
                                    {mergePreviewData.privacyPolicies
                                      ?.new_count || 0}{" "}
                                    | {t("sync.conflicts")}:{" "}
                                    {mergePreviewData.privacyPolicies
                                      ?.conflicts_count || 0}
                                  </div>
                                </div>
                              </div>
                              {/* Questionnaire (Survey Settings) */}
                              <div className="col-12 col-md-6">
                                <div
                                  style={{
                                    padding: "8px 10px",
                                    border: `1px solid ${(mergePreviewData.questionnaire?.conflicts_count || 0) > 0 ? "#ffeeba" : (mergePreviewData.questionnaire?.new_count || 0) > 0 ? "#badbcc" : "#e9ecef"}`,
                                    borderRadius: "4px",
                                    background:
                                      (mergePreviewData.questionnaire
                                        ?.conflicts_count || 0) > 0
                                        ? "#fff3cd"
                                        : (mergePreviewData.questionnaire
                                              ?.new_count || 0) > 0
                                          ? "#d1e7dd"
                                          : "#f8f9fa",
                                  }}
                                >
                                  <div style={{ fontWeight: 600 }}>
                                    {t("sync.questionnaire")}
                                  </div>
                                  <div style={{ color: "#6c757d" }}>
                                    {t("sync.new")}:{" "}
                                    {mergePreviewData.questionnaire
                                      ?.new_count || 0}{" "}
                                    | {t("sync.conflicts")}:{" "}
                                    {mergePreviewData.questionnaire
                                      ?.conflicts_count || 0}
                                  </div>
                                  {/* {mergePreviewData.questionnaire?.changedFieldsReadable?.length > 0 && (
                                  <div style={{ fontSize: '11px', color: '#856404', marginTop: '4px' }}>
                                    Changed: {mergePreviewData.questionnaire.changedFieldsReadable.join(', ')}
                                  </div>
                                )} */}
                                </div>
                              </div>
                              {/* ThankYouPage */}
                              <div className="col-12 col-md-6">
                                <div
                                  style={{
                                    padding: "8px 10px",
                                    border: `1px solid ${(mergePreviewData.thankYouPage?.conflicts_count || 0) > 0 ? "#ffeeba" : (mergePreviewData.thankYouPage?.new_count || 0) > 0 ? "#badbcc" : "#e9ecef"}`,
                                    borderRadius: "4px",
                                    background:
                                      (mergePreviewData.thankYouPage
                                        ?.conflicts_count || 0) > 0
                                        ? "#fff3cd"
                                        : (mergePreviewData.thankYouPage
                                              ?.new_count || 0) > 0
                                          ? "#d1e7dd"
                                          : "#f8f9fa",
                                  }}
                                >
                                  <div style={{ fontWeight: 600 }}>
                                    {t("sync.thankYouPage")}
                                  </div>
                                  <div style={{ color: "#6c757d" }}>
                                    {t("sync.new")}:{" "}
                                    {mergePreviewData.thankYouPage?.new_count ||
                                      0}{" "}
                                    | {t("sync.conflicts")}:{" "}
                                    {mergePreviewData.thankYouPage
                                      ?.conflicts_count || 0}
                                  </div>
                                  {/* {mergePreviewData.thankYouPage?.changedFieldsReadable?.length > 0 && (
                                  <div style={{ fontSize: '11px', color: '#856404', marginTop: '4px' }}>
                                    Changed: {mergePreviewData.thankYouPage.changedFieldsReadable.join(', ')}
                                  </div>
                                )} */}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Duplicates Info */}
                          {mergePreviewData.summary?.total_duplicates > 0 && (
                            <div
                              className="alert alert-secondary mb-3"
                              style={{ fontSize: "13px", padding: "12px" }}
                            >
                              <strong>
                                📋 {mergePreviewData.summary?.total_duplicates}{" "}
                                {t("sync.duplicatesWarning")}:
                              </strong>{" "}
                              {t("sync.duplicatesDescription")}
                            </div>
                          )}

                          {/* Details removed (per request). Show only counters. */}
                          {mergePreviewData.summary?.total_new === 0 &&
                            mergePreviewData.summary?.total_conflicts === 0 &&
                            mergePreviewData.summary?.total_duplicates ===
                              0 && (
                              <div
                                className="text-center text-muted"
                                style={{ padding: "10px 0" }}
                              >
                                {t("sync.noChanges")}
                              </div>
                            )}
                        </div>
                      )}

                      {/* Action Buttons */}
                      <div
                        className="button-wrap d-flex justify-content-end"
                        style={{ marginTop: "20px", paddingTop: "20px" }}
                      >
                        <button
                          type="button"
                          className="btn btn-bordered"
                          onClick={closeMergePreviewModal}
                          disabled={mergeExecuting}
                          style={{ padding: "8px 24px" }}
                        >
                          {t("sync.cancel")}
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary ms-3"
                          onClick={handleExecuteMerge}
                          disabled={
                            mergeExecuting ||
                            !mergePreviewData ||
                            (mergePreviewData.summary?.total_new === 0 &&
                              mergePreviewData.summary?.total_conflicts === 0 &&
                              mergePreviewData.summary?.total_duplicates === 0)
                          }
                          style={{ padding: "8px 24px" }}
                        >
                          {mergeExecuting
                            ? t("sync.merging")
                            : t("sync.acceptAndSync")}
                        </button>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="customvar-modal modal custom-modal fade deleteModal"
        id="deleteSurveyModal"
        tabIndex={-1}
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div
                  className={
                    "formvawrapper delete-modal-wrap modal-sm" +
                    " " +
                    style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-0" + " " + style.card}
                  >
                    <div className="delete-body-wrap delete-language">
                      <div className="heading">
                        <h3>{`${t("survey.actions.delete")} ${t("survey.title")}`}</h3>
                        <p>
                          {" "}
                          {t("survey.share.del1")}{" "}
                          <strong>{currentlyDeleting.name ?? ""}</strong>{" "}
                          {t("survey.customVariable.permanently")}{" "}
                        </p>
                      </div>

                      <div className="button-wrap d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-bordered"
                          data-bs-dismiss="modal"
                          onClick={() =>
                            setCurrentlyDeleting({
                              ...currentlyDeleting,
                              id: null,
                              name: null,
                            })
                          }
                        >
                          {t("settings.team.action.delete.cancel")}
                        </button>
                        <button
                          type="button"
                          className="btn btn-delete ms-3"
                          data-bs-dismiss="modal"
                          onClick={() =>
                            handleDeleteSurvey(currentlyDeleting.id)
                          }
                        >
                          {t("settings.team.action.delete.confirm_delete")}
                        </button>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal-backdrop fade ${isAssignModalOpen ? "show" : ""}`}
        style={{ display: `${isAssignModalOpen ? "block" : "none"}` }}
      ></div>

      <div
        className={`modal-backdrop fade ${isSyncOptionsModalOpen ? "show" : ""}`}
        style={{ display: `${isSyncOptionsModalOpen ? "block" : "none"}` }}
      ></div>

      <div
        className={`modal-backdrop fade ${isVersionHistoryModalOpen ? "show" : ""}`}
        style={{ display: `${isVersionHistoryModalOpen ? "block" : "none"}` }}
      ></div>

      <div
        className={`modal-backdrop fade ${isMergePreviewModalOpen ? "show" : ""}`}
        style={{ display: `${isMergePreviewModalOpen ? "block" : "none"}` }}
      ></div>

      <div
        className={`modal-backdrop fade ${isDuplicateSurveyModalOpen ? "show" : ""}`}
        style={{ display: `${isDuplicateSurveyModalOpen ? "block" : "none"}` }}
      ></div>
    </div>
  );
}
